import React from "react";
import styled from "styled-components";

import Card from "./card";

const Panel = styled(Card)`
    /* Temporary values */
    margin: 100px auto;

    width: ${props => props.width};
    height: ${props => props.height};

    position: relative;

    /* padding-top: 30px; */

    /* To fix margin collapsing */
    display: flex;
    flex-direction: column;
`;

const TitleBar = styled.div`
    width: 100%;
    height: 1.8em;
    background-color: #424147;
    border-radius: inherit;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    display: flex;
    align-items: center;

    position: absolute;
    top: 0;
    left: 0;
`;

const CommandButtons = () => {
    const CommandButton = styled.div`
        width: 0.5em;
        height: 0.5em;
        border-radius: 0.25em;
        background-color: #C4C4C4;
        margin-right: 0.4em;
        transition: background-color 0.1s;        
    `;
    const Group = styled.div`
        display: flex;
        margin-left: 1.25em;

        /* Surprise easter egg */
        &:hover {
            div:nth-child(1) { background-color: var(--kpum-orange); }
            div:nth-child(2) { background-color: var(--kpum-lightorange); }
            div:nth-child(3) { background-color: var(--kpum-teal); }
        }
    `;
    return (
        <Group>
            <CommandButton /><CommandButton /><CommandButton />
        </Group>
    );
}

const Content = styled.div`
    margin-top: 1.8em;
`;

const AppWindow = ({ children, width, height, style, className, contentContainerStyle }) => (
    <Panel width={width} height={height} style={style} className={className}>
        <TitleBar><CommandButtons /></TitleBar>
        <Content style={contentContainerStyle}>
            {children}
        </Content>
    </Panel>
);

export default AppWindow;